import React, {useContext, useEffect} from "react";
import {DatePicker, Form} from "antd";
import config from "../../../config";
import {replaceIndexAt} from "../../../utils/helpers/commonFunctions";
import {PurchaseContext} from "../../../context/PurchaseContext";
import moment from "moment";


const PurchaseShippingDate = ({record}) => {
    const {purchaseItems} = useContext(PurchaseContext)
    const [purchaseList, setPurchaseList] = purchaseItems
    const [form] = Form.useForm()

    useEffect(() => {
        if (record.shippingDate) {
            form.setFieldsValue({
                [`date-${record.key}`]: moment(record.shippingDate, "YYYY/MM/DD HH:mm")
            })
        } else {
            form.setFieldsValue({
                [`date-${record.key}`]: moment(new Date(), "YYYY/MM/DD HH:mm")
            })
        }
    }, [record.shippingDate])

    const handleDateChanged = (dateObj) => {
        const itemIndex = purchaseList.findIndex(item => item.key === record.key)
        const newList = replaceIndexAt(
            purchaseList,
            {
                ...purchaseList[itemIndex],
                shippingDate: dateObj._d
            },
            itemIndex
        )
        setPurchaseList(newList)
    }

    return (
        <React.Fragment>
            <Form form={form}>
                <Form.Item
                    style={{marginBottom: 0}}
                    name={`date-${record.key}`}
                >
                    <DatePicker key={`date-${record.key}`} onChange={handleDateChanged} format={config.userDateFormat}/>
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default PurchaseShippingDate